export const formatEmail = (email: string) =>
  `${email.substr(0, 2)}*****@****${email.substr(email.indexOf('@') + 6, email.length)}`

export const formatHidePhoneMask = (phone: string | undefined) => {
  if (phone?.includes('*')) return phone

  return `(${phone?.replace(/-|\s/g, '')?.slice(2)?.substr(0, 2)})*****-${phone?.substr(-4)}`
}

export function getFirstNameAndLastName(name: string): string | undefined {
  if (!name) return undefined

  const names = name.split(' ')

  const firstName = names[0]

  const lastName = names.length > 1 ? names[names.length - 1] : undefined

  const nameMount = lastName ? `${firstName} ${lastName}` : firstName

  return nameMount
}

// create a function that makes string capitalize
export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
